export type OrganizationRole = 'owner' | 'admin' | 'member';

export type TenantContext = {
  orgSlug: string;
  restaurantId: string;
  branchId: string;
};

export type OnboardingStatus = {
  hasOrg: boolean;
  hasRestaurant: boolean;
  hasBranch: boolean;
  organizationId: string | null;
  organizationSlug: string | null;
  firstRestaurantId: string | null;
  firstBranchId: string | null;
};

export type ContextSession = {
  emailVerified: boolean;
  organizationRole: OrganizationRole | null;
};

export type ContextResolution = { kind: 'render'; context: TenantContext } | { kind: 'redirect'; to: string };

export const ALL_BRANCHES = 'all';
